<template>
    <div class="relative">
        <div v-if="number > 0" class="bg-pink text-white absolute top-0 -right-2 rounded-full h-5 w-5 text-xs flex justify-center items-center">
            {{ number }}
        </div>
        <svg
            :class="number > 0 ? 'fill-current text-white' : null"
            :width="width" :height="height" viewBox="0 0 28 28"
            fill="none" xmlns="http://www.w3.org/2000/svg"
        >
            <circle :opacity="number > 0 ? 1 : 0.2" cx="14" cy="14" r="13.5" stroke="white"/>
            <path d="M9 10.6666H19M11 14H17M12.3333 17.3333H15.6667" :stroke="number > 0 ? 'black' : 'white'"/>
        </svg>
    </div>
</template>

<script>
export default {
    name: "AtomIcFilter",
    props: {
        width: {
            type: Number,
            default: 40
        },
        height: {
            type: Number,
            default: 40
        },
        number: {
            type: Number,
            default: 0
        }
    },
}
</script>
